module.exports = __webpack_public_path__ + "images/simple-lms-banner-bg.jpg";